import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AuthCardLayout from './authentication/AuthCardLayout';
import LoginForm from './authentication/LoginForm';
import api from '../../api/req';
import LoginFormKEP from './authentication/LoginFormKep';

function Login({ onLogin }) {
  const [loginMethod, setLoginMethod] = useState('password');
  const [requestIdFromKep, setRequestIdFromKep] = useState(null);
  const [requestIdFromPassword, setRequestIdFromPassword] = useState(null);
  const [signStringFromPassword, setSignStringFromPassword] = useState(null);

  useEffect(() => {
    const storedMethod = localStorage.getItem('defaultLogin');
    if (storedMethod === 'KEP' || storedMethod === 'password') {
      setLoginMethod(storedMethod);
    } else {
      setLoginMethod('password');
    }
  }, []);

  const handleSwitchMethod = useCallback(() => {
    const newMethod = loginMethod === 'KEP' ? 'password' : 'KEP';
    setLoginMethod(newMethod);
    localStorage.setItem('defaultLogin', newMethod);
  }, [loginMethod]);

  const ecpGet = useCallback(async () => {
    const r = await api.get('/api/ecp_form/', () => null);
    if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
    const d = await r.json();
    return { requestId: d.request_id, stringToSign: d.sign_string };
  }, []);

  const ecpPost = useCallback(async ({ requestId, signed }) => {
    const body = {
      request_id: requestId,
      sign_base64: signed,
    };
    const r = await api.post('/api/ecp_form/', () => null, body);
    if (!r.ok) {
      if (r.status === 400) {
        const d = await r.json();
        if (d.error) throw new Error(d.error);
      }
      throw new Error(`${r.status} ${r.statusText}`);
    }

    const data = await r.json();
    if (data.next_step) {
      setLoginMethod('password');
      setRequestIdFromKep(data.request_id);
    }
    return data;
  }, []);

  const passwordPost = useCallback(async ({ username, password }) => {
    const body = {
      username,
      password,
    };

    if (requestIdFromKep) {
      body.request_id = requestIdFromKep;
    }

    const r = await api.post('/api/token/', () => null, body);
    if (!r.ok) {
      const d = await r.json();
      if (d?.error) throw new Error(d.error);
      throw new Error(`${r.status} ${r.statusText}`);
    }

    const data = await r.json();

    if (data.next_step) {
      setLoginMethod('KEP');
      setRequestIdFromPassword(data.request_id);
      setSignStringFromPassword(data.sign_string);
    } else {
      onLogin(data.access, data.refresh);
    }

    return data;
  }, [onLogin, requestIdFromKep]);

  const onRequirePassword = useCallback(() => {
    setLoginMethod('password');
  }, []);
  const isWideMode = true;
  return (
    <AuthCardLayout
      isWideMode={isWideMode}
      loginMethod={loginMethod}
      handleSwitchMethod={handleSwitchMethod}
      hideSwitchLoginMethod={requestIdFromPassword || requestIdFromKep}
    >
      <h3 className="ms-5">Вхід до системи</h3>
      {loginMethod === 'KEP' ? (
        <LoginFormKEP
          isWideMode={isWideMode}
          ecpGet={requestIdFromPassword ? null : ecpGet}
          ecpPost={ecpPost}
          onLogin={onLogin}
          onRequirePassword={onRequirePassword}
          loginMethod={loginMethod}
          handleSwitchMethod={handleSwitchMethod}
          stringToSign={signStringFromPassword}
          requestId={requestIdFromPassword}
        />
      ) : (
        <LoginForm
          layout="card"
          passwordPost={passwordPost}
          hasLabel
        />
      )}

    </AuthCardLayout>
  );
}

Login.propTypes = {
  onLogin: PropTypes.func.isRequired,
};

export default Login;
